import { QueryErrorBoundary } from '@/components/shared/error-boundary-overlay/query-error-boundary'
import { SpendingOverviewChartCard } from '@/routes/home/spending-overview/chart-card'
import { SpendingOverviewFallback } from '@/routes/home/spending-overview/fallback'
import { BILLING_PERIOD_QUERY } from '@/routes/home/spending-overview/query'
import { BILLING_DAILY_USAGE_REPORT_QUERY } from '@/routes/usage/queries'

export const SpendingOverview = () => {
  return (
    <QueryErrorBoundary
      queries={[BILLING_PERIOD_QUERY, BILLING_DAILY_USAGE_REPORT_QUERY]}
      fallback={<SpendingOverviewFallback />}
    >
      <SpendingOverviewChartCard />
    </QueryErrorBoundary>
  )
}
